export default __webpack_public_path__ + "static/media/Avatar-16.697cf63e.svg";